var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockmanage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2876_15810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 6.25L14.1665 7.91667M14.1665 7.91667L13.7498 8.125L9.99984 10M14.1665 7.91667V10.8333M14.1665 7.91667L6.24984 3.75001M9.99984 10L2.49984 6.25M9.99984 10V17.9167M12.9815 2.81834L14.6482 3.69334C16.4407 4.63417 17.3373 5.10417 17.8357 5.95C18.3332 6.795 18.3332 7.84751 18.3332 9.95167V10.0492C18.3332 12.1525 18.3332 13.205 17.8357 14.05C17.3373 14.8958 16.4407 15.3667 14.6482 16.3075L12.9815 17.1817C11.5182 17.9492 10.7865 18.3333 9.99984 18.3333C9.21317 18.3333 8.4815 17.95 7.01817 17.1817L5.3515 16.3067C3.559 15.3658 2.66234 14.8958 2.164 14.05C1.6665 13.205 1.6665 12.1525 1.6665 10.05V9.9525C1.6665 7.84834 1.6665 6.79584 2.164 5.95084C2.66234 5.105 3.559 4.63417 5.3515 3.69417L7.01817 2.81917C8.4815 2.05084 9.21317 1.66667 9.99984 1.66667C10.7865 1.66667 11.5182 2.05001 12.9815 2.81834Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2876_15810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockmanage);
export default __webpack_public_path__ + "static/media/stockmanage.6b834696abaf05f00a2ea17b6bfafc00.svg";
export { ForwardRef as ReactComponent };